import ArraySnippetInterface from 'components/organisms/late-swap/services/array-snippet-interface';
import ArraySnippet from 'components/organisms/late-swap/services/array-snippet';
import LineupDetailsSnippetNotFoundError from './lineup-details-snippet-not-found-error';
import {lineupDetailsSnippetMap} from 'components/organisms/late-swap/services/maps';

const LineupDetailsSnippetFactory = {
    getSnippet(sportConfig): ArraySnippetInterface {
        const site = sportConfig.getSite().toLowerCase();

        try {
            return lineupDetailsSnippetMap[site]();
        } catch (e) {
            if (e instanceof TypeError) {
                throw new LineupDetailsSnippetNotFoundError('Snippet is undefined');
            }
            throw e;
        }
    },
};

export default LineupDetailsSnippetFactory;
